import { useResponsive } from 'Hooks';
import { clx } from 'Utils';

import styles from 'partials/card/subscription-card.module.scss';

export const SkeletonViewCreditDecorationBox = () => {
	const { isTabletAndAbove, isDesktopAndAbove } = useResponsive();

	const getImageSize = () => {
		return isDesktopAndAbove ? 160 : isTabletAndAbove ? 136 : 112;
	};

	return (
		<div
			className={clx(
				styles.body,
				'd-flex flex-column flex-md-row gap-3'
			)}>
			<div className={styles.logoBox}>
				<div
					className="skeletonStyle"
					style={{
						width: getImageSize(),
						height: getImageSize()
					}}
				/>
			</div>
			<div className="flex-grow-1">
				<>
					<div
						className="skeletonStyle"
						style={{
							width: '60%',
							height: '24px',
							marginBottom: '8px',
							display: 'flex'
						}}
					/>
					<div
						className="skeletonStyle"
						style={{
							width: '40%',
							height: '16px'
						}}
					/>
				</>
			</div>
		</div>
	);
};
